import { BAD_RFP_OFFER_MEMBER_DELETED, BAD_RFP_OFFER_MEMBER_INVALID_ADMIN_SETTING, BAD_RFP_OFFER_MEMBER_DUPLICATE_EMAIL, BAD_RFP_OFFER_MEMBER_CANT_INVITE_USER, BAD_RFP_OFFER_MEMBER_HAS_OTHER_OFFER, } from '@/utils/constants/api/responseCode';
/**
 * メンバー追加時のエラー
 */
export const RFP_ADD_MEMBER_ERROR_MESSAGES = {
    [BAD_RFP_OFFER_MEMBER_CANT_INVITE_USER]: '招待できないユーザーです',
    [BAD_RFP_OFFER_MEMBER_DELETED]: '招待できないユーザーです',
    [BAD_RFP_OFFER_MEMBER_DUPLICATE_EMAIL]: '既に招待済みのユーザーです',
    [BAD_RFP_OFFER_MEMBER_HAS_OTHER_OFFER]: 'このユーザーは既に提案済みのため、招待いただけません',
    [BAD_RFP_OFFER_MEMBER_INVALID_ADMIN_SETTING]: '責任者は1人までしか選択できません',
};
